export default __webpack_public_path__ + "static/media/yt.87fc96cb.gif";